import { render, staticRenderFns } from "./trxvendor.vue?vue&type=template&id=2e48fd10&scoped=true"
import script from "./trxvendor.vue?vue&type=script&lang=js"
export * from "./trxvendor.vue?vue&type=script&lang=js"
import style0 from "./trxvendor.vue?vue&type=style&index=0&id=2e48fd10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e48fd10",
  null
  
)

export default component.exports